<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            <h5>Mis suscripciones</h5>
            <div class="box-salir">
              <a @click="close"></a>
              <button
                type="button"
                class="btn-close"
                @click="close"
                aria-label="Cerrar ventana"
              >
                x
              </button>
            </div>
          </slot>
        </header>
        <section class="modal-body" id="modalDescription">
          <div name="body">
            <h2>Listado de beneficios a los que me suscribí</h2>
          </div>
          <div v-show="!cargandoLista">
            <div
              v-show="Cantidad <= 0"
              class="alert alert-primary info-sin-elementos"
              role="alert"
            >
              <p class="principal">No tienes suscripciones</p>
              <p class="extra">
                Para suscribirte haz click en un beneficio y presiona el botón
                de suscripción
              </p>
            </div>
            <draggable
              v-if="Cantidad > 0"
              v-model="misBeneficios"
              group="people"
              @start="arrastreIniciado()"
              @end="arrastreFinalizado()"
            >
              <transition-group class="box-cards-moda">
                <div
                  class="contenedor-individual-card"
                  v-for="ben in misBeneficios"
                  v-bind:key="ben.id"
                >
                  <!-- +Box cards nuevo -->

                  <div class="card-descuento">
                    <div class="contenedor-img-desc">
                      <img
                        :src="
                          sourceLogo + ben.comercio.logo + IndicadorMiniatura
                        "
                        alt=""
                      />
                    </div>
                    <div class="card-linc-desc">
                      <div class="corazon">
                        <h5
                          v-bind:style="{
                            'font-size': fontSizeLabel(
                              ben.descuentos[0].descuento
                            ),
                          }"
                        >
                          {{ ben.descuentos[0].descuento }}
                        </h5>
                        <font-awesome-icon :icon="appIcon4" />
                      </div>
                      <div class="sombra-corazon">
                        <font-awesome-icon :icon="appIcon4" />
                      </div>
                      <!-- <div class="btn-a-desc"></div> -->
                      <div class="contenedor-info">
                        <button
                          :disabled="idUltimoEliminado == ben.id"
                          @click="clickEliminar(ben)"
                        >
                          <span
                            v-if="idUltimoEliminado == ben.id"
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span v-if="idUltimoEliminado != ben.id"
                            >Cancelar</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div v-show="cargandoLista" class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <!-- -Box cards nuevo -->
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >
              Salir
            </button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import draggable from "vuedraggable";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Swal from "sweetalert2";
import { faEraser, faHeart } from "@fortawesome/free-solid-svg-icons";

import { Api } from "../../../api";
import { environment } from "../../../environments/environment";

const EVENTO_CERRAR = "close";

export default {
  name: "ModalSuscripciones",
  components: { draggable, FontAwesomeIcon },
  data() {
    return {
      algo: false,
      /** Indicador de carga de lista */
      cargandoLista: true,
      datosSuscripcion: {},
      /** DNI del cliente */
      dni: "",
      /** ID del último beneficio al que se le hizo click en eliminar,
       *  también sirve para mostrar feedback de carga mientras se elimina */
      idUltimoEliminado: null,
      misBeneficios: [],
      sourceLogo: "",
      token: "",
    };
  },
  computed: {
    appIcon2() {
      return faEraser;
    },
    appIcon4() {
      return faHeart;
    },
    Cantidad() {
      return this.misBeneficios.length;
    },
    /**Usado en las imágenes para indicar al servidor que se quiere una miniatura */
    IndicadorMiniatura() {
      return "/mini";
    },
  },
  methods: {
    /** Cuando se inicia el arrastre de una suscripción */
    arrastreIniciado() {},
    /** Cuando se finaliza el arrastre de una suscripción */
    arrastreFinalizado() {
      // Se crea una lista ordenada que contiene solo los id
      const listaOrdenada = this.misBeneficios.map((b) => b.id);
      Api.Suscripcion.ordenarCliente(listaOrdenada, this.dni, this.token);
    },
    close() {
      this.$emit(EVENTO_CERRAR);
    },
    clickEliminar(beneficio) {
      this.idUltimoEliminado = beneficio.id;

      const idCliente = localStorage.getItem("iduser");
      this.datosSuscripcion.idBeneficio = beneficio.id;
      this.datosSuscripcion.idCliente = idCliente;

      Api.Suscripcion.eliminar(this.datosSuscripcion, this.token)
        .then(() => {
          Swal.fire("Confirmación", "Suscripción eliminada", "warning");
          Api.Suscripcion.getCliente(this.dni, this.token).then((response) => {
            this.$emit("emited");
            this.misBeneficios = response.data;
          });
          this.$emit("suscripcion-cancelada", beneficio);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Funcion para adaptar texto dentro de corazon
    fontSizeLabel(palabra) {
      const cantCar = palabra.length;
      let newSizeFont = 100 / cantCar;
      newSizeFont = newSizeFont <= 0 ? 1 : newSizeFont;
      return "max(min(" + newSizeFont + "px, 26px) ,8px)";
    },
  },
  mounted() {
    this.dni = localStorage.getItem("dni");
    this.sourceLogo = environment.API_URL + "images/logos/";
    this.token = localStorage.getItem("token");

    Api.Suscripcion.getCliente(this.dni, this.token).then((response) => {
      this.misBeneficios = response.data;
      this.cargandoLista = false;
    });
  },
};
</script>

<style scoped>
.modal-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: var(--color-moda-h);
  box-shadow: 2px 2px 20px 1px;
  /* overflow-x: auto; */
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  width: 90%;
  position: initial;
  height: 100%;
  /* left: 25%; */
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  /* border-bottom: 1px solid #eeeeee; */
  /* color: #4aae9b; */
  justify-content: space-between;
  background: var(--color-estructura-a);
}

.modal-header h5 {
  font-family: var(--fuente-din);
  color: var(--color-estructura-c);
  font-size: 5vw;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
  background: var(--color-estructura-a);
}

.modal-footer p {
  color: var(--color-estructura-c);
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  overflow-y: scroll;
}

.modal-body div h2 {
  font-family: var(--fuente-din);
  font-size: 4vw;
  border-bottom: 2px solid var(--color-estructura-c);
}

.btn-close {
  border: none;
  font-size: 16px;
  padding: 0px !important;
  cursor: pointer;
  font-weight: bold;
  color: var(--color-estructura-c);
  background: transparent;
  margin-bottom: 50%;
  vertical-align: none;
  bottom: 1px;
  left: 2%;
  /* transform: translate(-24%, -22%); */
  transform: translate(-27%, 28%);
  /* -moz-transform: translate(-4px, -5px); */
  -moz-transform: translate(-22%, 29%);
  /*-webkit-transform: translate(-24%, -32%);*/ /* centrado en local */
  -webkit-transform: translate(-27%, 28%); /* centrado en prod */
}

.btn-close:focus {
  outline: none;
}

.box-salir {
  border: 1px solid var(--color-estructura-c);
  justify-self: right;
  position: relative;
  display: block;
  background: var(--color-estructura-a);
  border-radius: 25px;
  width: 25px;
  height: 25px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.box-salir a {
  position: absolute;
  background: transparent;
  border-radius: 25px;
  width: 25px;
  height: 25px;
  right: 0;
  cursor: pointer;
}

.box-salir:hover {
  background: white;
}

.btn-close:hover {
  color: black;
  border: none;
}

.btn-green {
  color: white;
  background: var(--color-estructura-c);
  border: 1px solid var(--color-estructura-c);
  border-radius: 2px;
}

.btn-green:hover {
  color: var(--color-estructura-a);
  background: white;
  border: 1px solid white;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/************ESTILOS DEL CARD****************/

/* .hello {
} */
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.shadow2 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow2:hover {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

/********************* +Categorias y Cards  ***********************/

.contenedor-categoria {
  display: flex;
}

.contenedor-categoria-moda hr {
  border-top: 2px solid var(--color-estructura-a);
  position: relative;
  top: 15px;
  left: 10px;
  width: 180px;
}

.contenedor-categoria-moda div {
  position: relative;
  text-align: left;
  width: 30px;
  margin-left: 30%;
  top: -28px;
}

.correccion {
  display: none;
}

.contenedor-categoria-moda div h4 {
  color: var(--color-estructura-a);
  margin-bottom: 20px;
}

.contenedor-categoria-moda div div h5,
.contenedor-categoria-moda div div h5 a {
  color: var(--color-estructura-a);
  cursor: pointer;
}

.contenedor-categoria-moda div div h5 a:hover {
  padding: 2px 20px 2px 20px;
  background: var(--color-estructura-c);
  font-weight: bold;
  /* transition-delay: 200ms; */
}

.contenedor-categoria-moda div div h5 a::after {
  background: var(--color-estructura-c);
  padding: 2px 20px 2px 20px;
}

.contenedor-individual-card {
  padding: 0 5px 0 5px !important;
  width: 150px !important;
  border-radius: 10px 10px 10px 10px !important;
  cursor: grab;
}

.grid-subcategorias {
  display: contents;
  height: 100%;
}

.card-descuento {
  position: relative;
  height: 230px;
  /* display: flex; */
  border: 0 !important;
  border-radius: 10px 10px 10px 10px !important;
}

.contenedor-img-desc {
  height: 160px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: gray;
  border-radius: 10px 10px 0 0 !important;
  position: relative;
}

.contenedor-img-desc img {
  border-radius: 10px 10px 0 0;
  width: 100%;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;
  position: absolute;
}

.corazon {
  color: var(--color-moda-h);
  font-size: 75px;
  position: absolute;
  z-index: 300;
  display: flex;
  height: 75px;
  width: 75px;
  bottom: 64px;
  flex-direction: column;
}

.corazon h5 {
  position: absolute;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 56px;
  font-size: 21px;
  font-family: var(--fuente-din);
  font-style: italic;
  font-stretch: condensed;
  font-weight: 500;
  text-align: center;
  width: 100%;
}

.corazon svg {
  overflow: visible !important;
  position: absolute;
  z-index: -1;
  top: 32px;
}

.sombra-corazon {
  color: #000000;
  opacity: 0.2;
  font-size: 80px;
  position: relative;
  bottom: 47px;
  z-index: 250;
  display: flex;
  left: -2px;
  height: 75px;
  width: 75px;
}

.card-linc-desc {
  /* z-index: 3000; */
  height: 60px;
  width: 140px;
  position: absolute;
  left: 0;
  justify-items: center;
  display: grid;
}

.contenedor-info {
  position: absolute;
  border-radius: 0 0 10px 10px !important;
  z-index: 0;
  background: white;
  width: 140px;
  bottom: 0;
}

.contenedor-info button {
  display: inline-flex;
  flex-direction: column-reverse;
  text-align: center;
  border-radius: 0 0 10px 10px;
  height: 60px;
  z-index: 100;
  width: 140px;
  padding-bottom: 7px;
  align-items: center;
}

.contenedor-info button:hover {
  border-color: rgb(40, 168, 69) !important;
  background: var(--color-estructura-c);
  text-decoration-color: currentcolor;
}

.contenedor-info button i {
  position: absolute;
  bottom: 28px;
  right: 20px;
  height: 0;
  color: black;
  z-index: 500;
  font-weight: bold;
}

.grid-contenedor-moda {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px auto;
  padding-top: 20px;
  background: var(--color-moda-h);
}

.box-menu-moda {
  text-align: left;
}

.box-cards-moda {
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-template-rows: 230px;
  align-items: center;
  justify-content: center;
}

/********************* -Categorias y Cards  ***********************/

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .modal-header h5 {
    font-size: 25px;
  }

  .modal-body div h2 {
    font-size: 20px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .modal-header h5 {
    font-size: 30px;
  }

  .modal-body div h2 {
    font-size: 25px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .btn-close {
    /* transform: translate(-28%, -34%); */
    transform: translate(-27%, 28%);
    /*-webkit-transform: translate(-24%, -32%);*/ /* centrado en local */
    -webkit-transform: translate(-27%, 28%); /* centrado en prod */
    -moz-transform: translate(-22%, 29%);
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
